"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserRoleAllowListed = isUserRoleAllowListed;
exports.isUserRoleDenyListed = isUserRoleDenyListed;
var isAccessPointWithinUserRoleScope_1 = require("./isAccessPointWithinUserRoleScope");
var isUnitGroupWithinScope_1 = require("./isUnitGroupWithinScope");
function isUserRoleAllowListed(accessPointRole, accessPoint, userRole) {
    var hasAccess = accessPointRole.hasAccess, roleId = accessPointRole.roleId, unitGroupId = accessPointRole.unitGroupId;
    var role = userRole.role, scopedUnit = userRole.scopedUnit;
    if (!hasAccess || roleId !== role.roleId) {
        // Role is either denied (ignored) OR allowed but doesn't match the user role
        return false;
    }
    if (!unitGroupId) {
        // User role is allowed as long as the AP is within scope
        return (0, isAccessPointWithinUserRoleScope_1.isAccessPointWithinUserRoleScope)(accessPoint, userRole);
    }
    if (!(scopedUnit === null || scopedUnit === void 0 ? void 0 : scopedUnit.unitGroup)) {
        // User role is not allowed. Access point role is configured for specific unit group
        return false;
    }
    return (0, isUnitGroupWithinScope_1.isUnitGroupWithinScope)(unitGroupId, scopedUnit.unitGroup);
}
function isUserRoleDenyListed(accessPointRole, userRole) {
    var hasAccess = accessPointRole.hasAccess, roleId = accessPointRole.roleId, unitGroupId = accessPointRole.unitGroupId;
    var role = userRole.role, scopedUnit = userRole.scopedUnit;
    if (hasAccess || roleId !== role.roleId) {
        // Role is either allowed (ignored) OR denied but doesn't match the user role
        return false;
    }
    if (!unitGroupId) {
        // User role is denied because the role matches and there is no unit group specified
        return true;
    }
    if (!(scopedUnit === null || scopedUnit === void 0 ? void 0 : scopedUnit.unitGroup)) {
        // User role is not denied. Access point role is configured for specific unit group
        return false;
    }
    return (0, isUnitGroupWithinScope_1.isUnitGroupWithinScope)(unitGroupId, scopedUnit.unitGroup);
}
//# sourceMappingURL=isUserRoleAllowedOrDenied.js.map